import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {HttpErrorResponse} from "@angular/common/http";
import {ErrorPopupService} from "@dabnet-kamu/libs/ui/shared/services/error-popup.service";
import {AppSettingsService} from "./app-settings.service";
import {ekranHataKaydi} from "./ekran-hata-kaydi"; // DKM-5193 Cedric
import {ekranHataKaydiServiceStackKur} from "./ekran-hata-kaydi-servicestack"; // dtokgoz 16.10

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor(
    private toastr: ToastrService,
    private popupService: ErrorPopupService,
    private appSettingsService: AppSettingsService,
  ) {
    // dtokgoz 16.10: JsonServiceClient (fetch) istekleri de hata kaynağı için son istek olarak kaydedilsin (bir kez kurulur)
    ekranHataKaydiServiceStackKur();
  }

  showSuccess(message = 'İşlem başarılı', header = '', position?: string): void {
    this.toastr.success(message, header, {
      timeOut: 3000,
      positionClass: position ? position : 'toast-top-right'
    });
  }


  showInfo(message: string, header: string, position?: string): void {
    this.toastr.info(message, header, {
      timeOut: 3000,
      positionClass: position ? position : 'toast-top-right'
    });
  }

  showWarning(message: string, header?: string, position?: string): void {
    this.toastr.warning(message, header, {
      timeOut: 3000,
      positionClass: position ? position : 'toast-top-right'
    });
  }

  turkishtoEnglish(value: string): string {
    return value
      .replace(/Ğ/gim, 'g')
      .replace(/Ü/gim, 'u')
      .replace(/Ş/gim, 's')
      .replace(/I/gim, 'i')
      .replace(/İ/gim, 'i')
      .replace(/Ö/gim, 'o')
      .replace(/Ç/gim, 'c')
      .replace(/ğ/gim, 'g')
      .replace(/ü/gim, 'u')
      .replace(/ş/gim, 's')
      .replace(/ı/gim, 'i')
      .replace(/ö/gim, 'o')
      .replace(/ç/gim, 'c');
  }

  showError(
    errorRes: any,
    header?: string,
    position?: string,
    usePopup?: boolean,
    addMessageToPopupHeader?: string
  ): void {
    let error;
    if (errorRes instanceof HttpErrorResponse) {
      error = errorRes;
    } else {
      if (errorRes?.message) {
        try {
          error = JSON.parse(errorRes.message);
        } catch {
          // JSON değilse direkt mesajı ata
          error = errorRes.message;
        }
      } else {
        error = errorRes;
      }
    }

    let toastMessage = '';
    let toastHeader = header || 'Hata!';
    let timeOut = 5000;
    let enableHtml = false;
    let listItems = '';
    let positionClass = position || 'toast-top-right';

    if (usePopup === undefined) {
      // DKM-4567 Cedric: eski hâli — ayar yoksa toaster'dı
      // usePopup = this.appSettingsService.appSettings?.errorShowType === 'popup';
      // DKM-4567 Cedric: varsayılan popup. errorShowType verildiyse ona uyulur ("popup" → popup, başka değer ör. "toast" → toaster);
      // verilmediyse popup — ama yalnız popup'ı gösterecek <dk-error-popup> takılıysa (dabnet-kamu). Takılı değilse
      // (e-belediye, mobile-kamu) eskisi gibi toaster; yoksa hata hiç görünmezdi.
      const errorShowType = String(this.appSettingsService.appSettings?.errorShowType ?? '').trim().toLowerCase();
      usePopup = errorShowType ? errorShowType === 'popup' : this.popupService.hasHost === true;
    }

    // DKM-5454 Cedric: servisin "Kayıt Öncesi Kontrol (DValidation/FValidation) Hataları mevcut" doğrulama hatası mı?
    // (popup'ta kırmızı "Servis hatası" yerine sarı "Validasyon uyarısı" gösterilir)
    let dogrulamaHatasi = false;
    // DKM-5454 Cedric: tek düz metin mesajı okunur hâle getirir (doğrulama başlığı, satır sonları, Bs grup eki).
    // Başlıksız, tek satırlık mesaj aynen kalır.
    const tekMesaj = (m: any): string => {
      const b = this.servisMetniBicimle(m);
      dogrulamaHatasi = dogrulamaHatasi || b.dogrulama;
      if (b.html) {
        enableHtml = true;
      }
      return b.metin;
    };

    // Birden fazla mesaj varsa liste, tek mesaj varsa düz metin olarak ayarlar
    const setMessages = (msgs: string[]) => {
      if (msgs.length > 1) {
        // DKM-5454 Cedric: eski hâli — satır sonları ve doğrulama başlığı olduğu gibi kalıyordu
        // toastMessage = '<ul>' + msgs.map(m => `<li>${this.escapeHtml(m)}</li>`).join('') + '</ul>';
        // Dataservices 422 gövdesi {Error: {Message: "<başlık>", Details: [...]}} → başlık tek başına bir mesaj olarak gelir;
        // boşalan mesaj atılır, doğrulama varsa diğer mesajlardaki Bs grup eki de atılır.
        const bicimli = msgs.map(m => this.servisMetniBicimle(m));
        const dogrulama = bicimli.some(b => b.dogrulama);
        dogrulamaHatasi = dogrulamaHatasi || dogrulama;
        const ogeler = [...new Set(bicimli
          .map(b => (b.html && !b.kaynakHtml) ? b.metin : this.escapeHtml(dogrulama ? this.grupEkiAt(b.metin) : b.metin))
          .filter(x => typeof x === 'string' && x.trim()))];
        toastMessage = ogeler.length > 1
          ? '<ul>' + ogeler.map(x => `<li>${x}</li>`).join('') + '</ul>'
          : (ogeler[0] ?? 'İşlem gerçekleştirilemedi!');
        enableHtml = true;
        timeOut = 20000;
      } else {
        // DKM-5454 Cedric: eski hâli
        // toastMessage = msgs[0];
        toastMessage = tekMesaj(msgs[0]);
        timeOut = 15000;
      }
    };

    if (error?.Error) {
      // Error nesnesi mevcutsa
      toastHeader = toastHeader || error.Error.Code || 'Hata!';

      if (error.Error.Details?.length > 0) {
        // Detaylı hata mesajı mevcut
        listItems = '<ul>';
        error.Error.Details.forEach((item: any) => {
          // DKM-5454 Cedric: eski hâli — kaçışsız ve Bs grup ekiyle ("... (BysBelgeHavale)") basılıyordu
          // listItems += `<li>${item.Message}</li>`;
          listItems += `<li>${this.escapeHtml(this.grupEkiAt(String(item?.Message ?? '')))}</li>`;
        });
        listItems += '</ul>';
        // DKM-5454 Cedric: eski hâli — tek mesaj da madde listesi olarak çıkıyordu
        // toastMessage = listItems;
        toastMessage = error.Error.Details.length === 1
          ? this.escapeHtml(this.grupEkiAt(String(error.Error.Details[0]?.Message ?? '')))
          : listItems;
        timeOut = 20000;
        enableHtml = true;
      } else {
        // Detaylı mesaj yoksa genel hata mesajını al
        // DKM-5454 Cedric: eski hâli
        // toastMessage = error.Error.Message;
        toastMessage = tekMesaj(error.Error.Message);
        timeOut = 15000;
      }
    } else if (error instanceof HttpErrorResponse) {
      // HttpErrorResponse tipi gelen hata
      toastHeader = 'İşlem Başarısız!';
      timeOut = 10000;

      if (error.status === 0) {
        // Sunucuya ulaşılamadı
        toastMessage = 'Lütfen bağlantınızı kontrol edin!';
      } else if (error.status >= 400 && error.status < 500) {
        // İstemci hatası (4xx)
        toastHeader = `Hata Kodu: ${error.status}`;
        const body = error.error;
        if (!body || typeof body === 'string') {
          toastMessage = body || 'İşlem sırasında bir hata oluştu!';
        } else {
          // Gövde obje ise (ServiceStack ResponseStatus / BaseResponse) mesajı içinden çıkar
          const msgs = this.extractServiceMessages(body);
          if (msgs.length) {
            setMessages(msgs);
          } else {
            toastMessage = 'İşlem sırasında bir hata oluştu!';
          }
        }
      } else if (error.status >= 500) {
        // Sunucu hatası (5xx)
        toastHeader = `Hata Kodu: ${error.status}`;
        const body = error.error;
        // HTML hata sayfaları (IIS vb.) gösterilmez
        const msgs = typeof body === 'string'
          ? (body.trim() && !body.trim().startsWith('<') ? [body.trim()] : [])
          : this.extractServiceMessages(body);
        if (msgs.length) {
          toastMessage = 'Sunucuda bir hata oluştu. Lütfen sistem yöneticinize iletin.<br>Detay: '
            + msgs.map(m => this.escapeHtml(m)).join('<br>');
          enableHtml = true;
          timeOut = 20000;
        } else {
          toastMessage = 'Kayıt esnasında bir hata meydana geldi. Lütfen daha sonra tekrar deneyin!';
        }
      } else {
        // Genel hata mesajı
        toastMessage = `Hata Kodu: ${error.status}, Mesaj: ${error.statusText}`;
      }
    } else if (typeof error === 'string') {
      // Gelen hata string ise
      // DKM-5454 Cedric: eski hâli
      // toastMessage = error;
      toastMessage = tekMesaj(error);
      toastHeader = toastHeader || 'İşlem Başarısız';
    } else {
      // ServiceStack ApiResult / BaseResponse / ResponseStatus geldiyse mesajı içinden çıkar
      const msgs = this.extractServiceMessages(error);
      if (msgs.length) {
        setMessages(msgs);
      } else {
        // Genel fallback mesajı
        toastMessage = 'İşlem gerçekleştirilemedi!';
      }
    }

    // DKM-5193 Cedric: kullanıcının gördüğü hatayı ekran hata kaydına da yaz (yalnız okur; akış/mesaj aynen kalır)
    try {
      ekranHataKaydi.ekran(toastHeader, toastMessage);
    } catch {
      // kayıt yazılamazsa hata gösterimi etkilenmez
    }

    // Eğer popup kullanılacaksa toastr yerine dxPopup aç
    if (usePopup) {
      console.log(errorRes)

      // DevExtreme notify (basit) versiyonu
      // notify({ message: toastMessage, width: 400 }, 'error', timeOut);

      // Eğer daha dikkat çekici popup istiyorsan Angular tarafında
      // global bir popup service oluşturup buradan trigger edebilirsin
      // DKM-5454 Cedric: ServiceStack BaseResponse.errorCode (DValidationError/ValidationError) ve metindeki
      // "Kayıt Öncesi Kontrol (...) Hataları mevcut" başlığı da doğrulama uyarısı sayılır
      const hataKodu = error?.Error?.Code ?? errorRes?.response?.errorCode ?? errorRes?.errorCode;
      const uyari = hataKodu === 'DValidationError' || hataKodu === 'ValidationError' || dogrulamaHatasi;
      this.popupService.open({
        title: (header || '') + ((header && addMessageToPopupHeader)? ' ':'') + (addMessageToPopupHeader || ''),
        message: toastMessage,
        // DKM-5454 Cedric: eski hâli
        // type: (error?.Error?.Code === 'DValidationError')? "warning" : "error",
        type: uyari ? "warning" : "error",
      });
    } else {
      // Toastr ile hata mesajını göster
      this.toastr.error(toastMessage, toastHeader, {
        timeOut,
        newestOnTop: false,
        disableTimeOut: false,
        enableHtml,
        closeButton: true,
        positionClass,
      });
    }
  }

  /**
   * DKM-5193 Cedric: footer "Hata Mesajları" — ekran hata kaydındaki son hataların listesi.
   * `html` ekranHataKaydi.listeHtml ile kaçışlı üretilir. showError'dan geçmez (listenin kendisi yeni hata kaydı açmasın).
   */
  showHataListesi(baslik: string, html: string, position = 'toast-bottom-full-width'): void {
    this.toastr.warning(html, baslik, {
      timeOut: 30000,
      extendedTimeOut: 10000,
      enableHtml: true,
      closeButton: true,
      newestOnTop: false,
      positionClass: position,
    });
  }

  /**
   * ServiceStack cevap şekillerinden hata mesajlarını toplar:
   * ApiResult ({response, error}), ErrorResponse ({responseStatus}), ResponseStatus ({message, errors}),
   * BaseResponse ({errorMessage, errors, errorDetails, vError}) ve dataservices ({Error: {Message, Details}}).
   * stackTrace bilerek alınmaz.
   */
  private extractServiceMessages(obj: any, depth = 0): string[] {
    if (!obj || typeof obj !== 'object' || depth > 3) {
      return [];
    }
    const msgs: string[] = [];
    const add = (v: any) => {
      const m = (v && typeof v === 'object')
        ? (v.message ?? v.Message ?? v.errorMessage ?? v.ErrorMessage)
        : v;
      if (typeof m === 'string' && m.trim()) {
        msgs.push(m.trim());
      }
    };
    const addList = (list: any) => {
      if (Array.isArray(list)) {
        list.forEach(add);
      }
    };

    const status = obj.responseStatus ?? obj.ResponseStatus;
    if (status) {
      msgs.push(...this.extractServiceMessages(status, depth + 1));
    }
    if ('response' in obj || 'error' in obj) {
      msgs.push(...this.extractServiceMessages(obj.error, depth + 1));
      msgs.push(...this.extractServiceMessages(obj.response, depth + 1));
    }
    if (obj.Error && typeof obj.Error === 'object') {
      add(obj.Error.Message);
      addList(obj.Error.Details);
    }
    add(obj.message);
    add(obj.Message);
    add(obj.errorMessage);
    add(obj.ErrorMessage);
    addList(obj.errors);
    addList(obj.Errors);
    addList(obj.errorDetails);
    addList(obj.ErrorDetails);
    addList(obj.vError?.errors);

    return [...new Set(msgs)];
  }

  /**
   * DKM-5454 Cedric: servis hata metnini kullanıcıya okunur verir. ServiceCore.GetBaseResponse doğrulama hatasını
   * `"Kayıt Öncesi Kontrol (DValidation) Hataları mevcut " + mesaj1 + "\r\n" + mesaj2 …` olarak döndürüyor; her mesajın
   * sonunda da DValidationResult grup adı (Bs sınıfı, ör. " (BysBelgeHavale)") var. Popup `[innerHTML]` ile, toastr düz
   * metin olarak gösterdiği için satır sonları kayboluyor, başlık mesaja yapışıyor ve hepsi tek paragraf görünüyordu.
   * - Başlık metinden çıkarılır (`dogrulama=true` → popup sarı "Validasyon uyarısı"); başlıktan önceki ekran metni
   *   (ör. "Bilgi Havalelerinde Hata:") ayrı satırda kalır, birden çok doğrulama mesajı madde listesi olur.
   * - Doğrulama mesajlarının sonundaki Bs grup eki atılır.
   * - Düz metindeki satır sonları `<br>` olur (metin kaçışlanır, `html=true`).
   * - HTML içeren metne (çağıran bilerek `<br>` vb. vermiş) yalnız başlık çıkarma uygulanır; başlıksız tek satırlık metin aynen döner.
   */
  private servisMetniBicimle(deger: any): { metin: any; html: boolean; dogrulama: boolean; kaynakHtml?: boolean } {
    if (typeof deger !== 'string') {
      return { metin: deger, html: false, dogrulama: false };
    }
    const baslik = /Kayıt Öncesi Kontrol \([DF]Validation\) Hataları mevcut[ \t]*/i;
    const dogrulama = baslik.test(deger);
    if (/<\/?[a-z][^>]*>/i.test(deger)) {
      return { metin: dogrulama ? deger.replace(baslik, '') : deger, html: false, dogrulama, kaynakHtml: true };
    }
    if (!dogrulama && !/[\r\n]/.test(deger.trim())) {
      return { metin: deger, html: false, dogrulama: false };
    }
    const satirlar = (s: string) => [...new Set(s.split(/\r?\n/).map(x => x.trim()).filter(Boolean))];
    if (!dogrulama) {
      const s = satirlar(deger);
      return s.length > 1
        ? { metin: s.map(x => this.escapeHtml(x)).join('<br>'), html: true, dogrulama: false }
        : { metin: s[0] ?? deger, html: false, dogrulama: false };
    }
    const i = deger.search(baslik);
    const onceki = satirlar(deger.slice(0, i));
    const hatalar = satirlar(deger.slice(i).replace(baslik, '')).map(x => this.grupEkiAt(x)).filter(Boolean);
    if (!onceki.length && hatalar.length <= 1) {
      return { metin: hatalar[0] ?? deger.replace(baslik, '').trim(), html: false, dogrulama };
    }
    const ust = onceki.map(x => this.escapeHtml(x)).join('<br>');
    const alt = hatalar.length > 1
      ? '<ul>' + hatalar.map(x => `<li>${this.escapeHtml(x)}</li>`).join('') + '</ul>'
      : this.escapeHtml(hatalar[0] ?? '');
    return { metin: ust && hatalar.length === 1 ? `${ust}<br>${alt}` : ust + alt, html: true, dogrulama };
  }

  /** DKM-5454 Cedric: DValidationResult'ın mesaj sonuna eklediği Bs grup adını (" (BysBelgeHavale)") atar. */
  private grupEkiAt(metin: string): string {
    return String(metin ?? '').replace(/\s+\((?:[A-ZÇĞİÖŞÜ][a-zçğıöşü0-9]+){2,}\)\s*$/, '').trim();
  }

  private escapeHtml(value: string): string {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }



  // showError(errorRes: any, header?: string, position?: string): void {
  //   let error;
  //   if (errorRes instanceof HttpErrorResponse) {
  //     error = errorRes;
  //   } else {
  //     if (errorRes?.message) {
  //       try {
  //         error = JSON.parse(errorRes.message);
  //       } catch {
  //         // JSON değilse direkt mesajı ata
  //         error = errorRes.message;
  //       }
  //     } else {
  //       error = errorRes;
  //     }
  //   }
  //
  //   let toastMessage = '';
  //   let toastHeader = header || 'Hata!';
  //   let timeOut = 5000;
  //   let enableHtml = false;
  //   let listItems = '';
  //   let positionClass = position || 'toast-top-right';
  //
  //   if (error?.Error) {
  //     // Error nesnesi mevcutsa
  //     toastHeader = toastHeader || error.Error.Code || 'Hata!';
  //
  //     if (error.Error.Details?.length > 0) {
  //       // Detaylı hata mesajı mevcut
  //       listItems = '<ul>';
  //       error.Error.Details.forEach((item: any) => {
  //         listItems += `<li>${item.Message}</li>`;
  //       });
  //       listItems += '</ul>';
  //       toastMessage = listItems;
  //       timeOut = 20000;
  //       enableHtml = true;
  //     } else {
  //       // Detaylı mesaj yoksa genel hata mesajını al
  //       toastMessage = error.Error.Message;
  //       timeOut = 15000;
  //     }
  //   } else if (error instanceof HttpErrorResponse) {
  //     // HttpErrorResponse tipi gelen hata
  //     toastHeader = 'İşlem Başarısız!';
  //     timeOut = 10000;
  //
  //     if (error.status === 0) {
  //       // Sunucuya ulaşılamadı
  //       toastMessage = 'Lütfen bağlantınızı kontrol edin!';
  //     } else if (error.status >= 400 && error.status < 500) {
  //       // İstemci hatası (4xx)
  //       toastHeader = `Hata Kodu: ${error.status}`;
  //       toastMessage = error.error || 'İşlem sırasında bir hata oluştu!';
  //     } else if (error.status >= 500) {
  //       // Sunucu hatası (5xx)
  //       toastHeader = `Hata Kodu: ${error.status}`;
  //       toastMessage = 'Kayıt esnasında bir hata meydana geldi. Lütfen daha sonra tekrar deneyin!';
  //     } else {
  //       // Genel hata mesajı
  //       toastMessage = `Hata Kodu: ${error.status}, Mesaj: ${error.statusText}`;
  //     }
  //   } else if (typeof error === 'string') {
  //     // Gelen hata string ise
  //     toastMessage = error;
  //     toastHeader = toastHeader || 'İşlem Başarısız';
  //   } else {
  //     // Genel fallback mesajı
  //     toastMessage = 'İşlem gerçekleştirilemedi!';
  //   }
  //
  //   // Toastr ile hata mesajını göster
  //   this.toastr.error(toastMessage, toastHeader, {
  //     timeOut,
  //     newestOnTop: false,
  //     disableTimeOut: false,
  //     enableHtml,
  //     closeButton: true,
  //     positionClass,
  //   });
  // }


  formatDate(dateGet: any): string | null {
    // 1. Değer kontrolü: null, undefined veya boş string ise null dön
    if (!dateGet) {
      return null;
    }

    const date = new Date(dateGet);

    // 2. Geçerli bir tarih mi kontrolü (Örn: "abc" gelirse patlamasın)
    if (isNaN(date.getTime())) {
      return null;
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}T00:00:00`;
  }


}
